import { Playground } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Description } from '../../../components/Description';
import { Title } from '../../../components/Title';
import { dummyText } from '../../../utils/data';

export const TextBox = () => (
    <div>
        <Description headline='Text box' anchor='text-box'>
            The text-box properties enable trimming off extra spacing from the block-start edge and block-end edge of a
            text element's block container.
        </Description>
        <Playground example={textBoxExample} classes={textBoxClasses} />
    </div>
);

const textBoxExample = (
    <div className='space-y-50'>
        <div className='display-flex gap-50 flex-wrap'>
            <div>
                <Title>text-box-trim-start</Title>
                <div className='display-flex gap-15 border border-style-dashed max-width-500'>
                    <div className='flex-0 height-150 width-150 bg-info' />
                    <div className='text-box-trim-start'>{dummyText}</div>
                </div>
            </div>
            <div>
                <Title>text-box-trim-both</Title>
                <div className='display-flex gap-15 border border-style-dashed max-width-500'>
                    <div className='flex-0 height-150 width-150 bg-info' />
                    <div className='text-box-trim-both'>{dummyText}</div>
                </div>
            </div>
        </div>
        <div className='display-flex gap-50 flex-wrap'>
            <div>
                <Title>text-box-auto</Title>
                <div className='display-flex gap-15 border border-style-dashed max-width-500'>
                    <div className='flex-0 height-150 width-150 bg-info' />
                    <div className='text-box-auto'>{dummyText}</div>
                </div>
            </div>
            <div>
                <Title>no text-box</Title>
                <div className='display-flex gap-15 border border-style-dashed max-width-500'>
                    <div className='flex-0 height-150 width-150 bg-info' />
                    <div className=''>{dummyText}</div>
                </div>
            </div>
        </div>
    </div>
);

const textBoxClasses = (
    <>
        <PlaygroundClasses label='Text box' prefix='text-box' classes={['normal', 'auto', 'trim-start', 'trim-both']} />
    </>
);
